import { LabraVenturesTheme } from '@labrav/react-components'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isViewOnly: boolean }>()(
  (theme: LabraVenturesTheme, { isViewOnly }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(4, 2, 4, 5),
    },
    topContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginRight: theme.spacing(2),
    },
    templateNameContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    name: {
      fontSize: '22px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '28px',
      color: theme.palette.labraText.primary,
      fontFamily: theme.typography.fontFamily,
      letterSpacing: '0px',
    },
    icon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      fontSize: '16px',
      color: theme.palette.select.light,
      opacity: isViewOnly ? 0.38 : 1,
    },
    hubspotIcon: {
      height: theme.spacing(3),
      width: theme.spacing(10.25),
    },
    middleContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(4),
      marginRight: theme.spacing(2),
    },
    columnActionContainer: {
      height: theme.spacing(3),
      width: theme.spacing(3),
      alignContent: 'center',
    },
    bottomContainer: {
      display: 'flex',
      marginTop: theme.spacing(1),
    },
    footerWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: theme.spacing(3),
    },
    footerRoot: {
      height: theme.spacing(8),
      padding: theme.spacing(1.5, 5),
    },
    loadingSpinner: {
      color: `${theme.palette.button.secondary} !important`,
      width: '20px !important',
      height: '20px !important',
      marginLeft: 'auto',
      marginRight: 'auto',
      opacity: 1,
      marginTop: theme.spacing(4),
    },
  })
)
